import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';
import { appTypeGuard } from './core/app-type.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'hospital/passport/login', pathMatch: 'full' },
      {
        path: 'user',
        loadChildren: () => import('src/app/user/user.module').then(m => m.UserModule)
      },
      {
        path: 'hospital',
        canActivate: [appTypeGuard],
        data: { appType: 6 },
        loadChildren: () => import('src/app/hospital/hospital.module').then(m => m.HospitalModule)
      },
      {
        path: 'pharmacy',
        canActivate: [appTypeGuard],
        data: { appType: 3 },
        loadChildren: () => import('src/app/pharmacy/pharmacy.module').then(m => m.PharmacyModule)
      },
      {
        path: 'distributor',
        canActivate: [appTypeGuard],
        data: { appType: 5 },
        loadChildren: () => import('src/app/distributor/distributor.module').then(m => m.DistributorModule)
      },
      {
        path: 'admin',
        canActivate: [appTypeGuard],
        data: { appType: 1 },
        loadChildren: () => import('src/app/admin/admin.module').then(m => m.AdminModule)
      },
      { path: '**', redirectTo: 'hospital/passport/login', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
      // Pls refer to https://ng-alain.com/components/reuse-tab
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
